// extracted by mini-css-extract-plugin
module.exports = {"bannerComponent":"jj","red":"kj","calloutlink":"lj","headerTopBanner":"mj","bgcolorRed":"nj","headerTopCallout":"oj","searchBanner":"pj","hideMobile":"qj"};